import controller from './register.controller';

export default {
  bindings: {
    countryCode: '<'
  },
  controller,
  template: require('./register.html')
};



// WEBPACK FOOTER //
// src/app/components/login-dialog/register/register.component.ts